import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration for zikaron-dalia
export const firebaseConfig = {
  apiKey: "AIzaSyAc6Qq20Ouvoo2ScEs3QlnwkfflcyrDcls",
  authDomain: "dalia-605c0.firebaseapp.com",
  projectId: "dalia-605c0",
  storageBucket: "dalia-605c0.firebasestorage.app",
  messagingSenderId: "1079288379629",
  appId: "1:1079288379629:web:d2d24ee9b4b076092874e4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
